import { createContext, useContext, useState } from "react";
import { BookingDialog } from "./BookingDialog";

const Ctx = createContext({ openBooking: () => {} });
export const useBooking = () => useContext(Ctx);

export const BookingProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, service: "psychic-reading", moon: "" });
  const openBooking = (service, moon = "") => setState({ open: true, service: service || state.service, moon });
  return (
    <Ctx.Provider value={{ openBooking }}>
      {children}
      <BookingDialog open={state.open} service={state.service} moon={state.moon} onOpenChange={(o) => setState((s) => ({ ...s, open: o }))} />
    </Ctx.Provider>
  );
};
